module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-ol-ebc-footer_6ce91c2.png";